import React from 'react';
import { connect } from 'react-redux';
import LogoImg from './assets/logo.svg';
import ChatContainer from './chatContainer.jsx';

import styles from "./style.css";

/**
 * Main Copilot component.
 */

const CopilotWindow = ({ locale, vm }) => {
    const [showChat, setShowChat] = React.useState(false);

    return (
        <div className={styles.copilot}>
            <button onClick={() => setShowChat(!showChat)} className={styles.iconbutton}>
                <img src={LogoImg} />
            </button>
            <ChatContainer vm={vm} locale={locale} showChat={showChat} setShowChat={setShowChat}></ChatContainer>
        </div>
    )
}

const mapStateToProps = state => ({
    locale: state.locales.locale,
    vm: state.scratchGui.vm
})
export default connect(mapStateToProps)(CopilotWindow);